export const SCHENGEN_ZONE = 'schengen';
export const NON_SCHENGEN_ZONE = 'nonschengen';
